import { render } from "./RateStylist.vue?vue&type=template&id=5accf768&scoped=true"
import script from "./RateStylist.vue?vue&type=script&lang=js"
export * from "./RateStylist.vue?vue&type=script&lang=js"

import "./RateStylist.vue?vue&type=style&index=0&id=5accf768&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5accf768"]])

export default __exports__